module.exports = __webpack_public_path__ + "img/pr-1.ea1456d8.png";